import yup from 'schemas/validation/feature'
import { equals, either, isNil } from 'ramda'
import {
  ANALOG_INPUT,
  DIGITAL_INPUT,
  FEATURE_MODULE_NAMES_WITH_HARNESSES,
} from 'utils/constants'
import { INTERNAL } from 'constants/featureTypes'
import strings from 'utils/strings'

import { isSingleSimpleCondition } from './utils'

const subTypeTestConfig = {
  is: (subType, contextSubType, featureModuleName, featureType) =>
    either(
      equals(ANALOG_INPUT),
      equals(DIGITAL_INPUT)
    )(subType || contextSubType) &&
    FEATURE_MODULE_NAMES_WITH_HARNESSES.includes(featureModuleName) &&
    featureType === INTERNAL,
  then: yup.string().nullable().hasIn('pinSet', strings.must_assign_harness),
}

const signalSchema = yup
  .string()
  .nullable()
  .when(
    ['subType', '$subType', '$featureModuleName', '$featureType'],
    subTypeTestConfig
  )
  // handles singleCondition signal or floatingCircuit needing to be defined
  .when(['floatingCircuit', 'parentQueryUri', 'queryType', 'subType'], {
    is: (floatingCircuit, ...rest) =>
      isSingleSimpleCondition(rest) && isNil(floatingCircuit),
    then: yup.string().required().nullable(),
  })
  .when('$isTimerActivateCondition', (isTimerActivateCondition, schema) =>
    isTimerActivateCondition ? yup.string().required().nullable() : schema
  )

export default signalSchema
